module.exports = __webpack_public_path__ + "img/page-home-container2-title.272b2636.png";